import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HttpClientModule} from '@angular/common/http';
import {QuotationService} from './services/quotation-service/quotation.service';
import {ValidationService} from './services/validation-service/validation.service';
import {LeadService} from './services/lead-service/lead.service';
import {QuotationTrackerComponent} from './components/quotation-tracker/quotation-tracker.component';
import {StepOneComponent} from './components/step-one/step-one.component';
import {StepTwoComponent} from './components/step-two/step-two.component';
import {StepThreeComponent} from './components/step-three/step-three.component';
import {RouterModule, Routes} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ContentComponent} from './components/content/content.component';
import {ErrorComponent} from './components/error/error.component';
import {StriphtmlPipe} from './pipes/strip-html/striphtml.pipe';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ThankYouComponent} from './components/thank-you/thank-you.component';
import {QuotePipe} from './pipes/quote/quote.pipe';
import { MoreVehicleInfoComponent } from './components/more-vehicle-info/more-vehicle-info.component';
import {SlickCarouselModule} from 'ngx-slick-carousel';
import {EarlyExitComponent} from "./components/early-exit/early-exit.component";
import {CampaignTrackingService} from "./services/campaign-tracking/campaign-tracking.service";
import {LeadFormComponent} from "./components/lead-form/lead-form.component";
import {CookieService} from "ngx-cookie-service";
import {DiscoveryGa4AngularService} from "discovery-ga4-angular";
import {QuoteStepOneComponent} from "./components/online-activation-journey/quote-step-one/quote-step-one.component";
import {GoogleAnalyticsService} from "google-analytics";
import {GtmService} from "./services/gtm-service/gtm.service";
import {StepperComponent} from "./components/online-activation-journey/stepper/stepper.component";
import {QuoteStepTwoComponent} from "./components/online-activation-journey/quote-step-two/quote-step-two.component";
import {
  MainDriverDetailsComponent
} from "./components/online-activation-journey/quote-step-two/main-driver-details/main-driver-details.component";
import {
  ParkingQuestionsComponent
} from "./components/online-activation-journey/quote-step-two/parking-questions/parking-questions.component";
import {
  SearchByMakeComponent
} from "./components/online-activation-journey/quote-step-two/search-by-make/search-by-make.component";
import {
  LicenseDetailsComponent
} from "./components/online-activation-journey/quote-step-two/license-details/license-details.component";
import {
  QuoteStepThreeComponent
} from "./components/online-activation-journey/quote-step-three/quote-step-three.component";
import {
  ActivationPlanholderDetailsComponent
} from "./components/online-activation-journey/activation-planholder-details/activation-planholder-details.component";
import {ActivationBankingDetailsComponent} from "./components/online-activation-journey/activation-banking-details/activation-banking-details.component";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {
  ActivationVehicleDetailsComponent
} from "./components/online-activation-journey/activation-vehicle-details/activation-vehicle-details.component";
import {
  ActivationCoverDetailsComponent
} from "./components/online-activation-journey/activation-cover-details/activation-cover-details.component";
import {ActivationQuoteActivateDetailsComponent} from "./components/online-activation-journey/activation-quote-activate-details/activation-quote-activate-details.component";
import {PremiumBannerComponent} from "./components/online-activation-journey/premium-banner/premium-banner.component";
import {ScrollDirective} from "../assets/scroll.directive";


const routes: Routes = [
  {path: '', redirectTo: 'quote-step-one', pathMatch: 'full'},
  {path: 'error', component: ErrorComponent},
  {path: 'get-insurance-quote', component: QuotationTrackerComponent},
  {path: 'thank-you', component: ThankYouComponent},
  {path: 'early-exit-survey', component: EarlyExitComponent},
  {path: 'quote-step-one', component: QuoteStepOneComponent},
  {path: 'quote-step-two', component: QuoteStepTwoComponent},
  {path: 'quote-step-three', component: QuoteStepThreeComponent},
  {path: 'activation-planholder-details', component: ActivationPlanholderDetailsComponent},
  {path: 'activation-banking-details', component: ActivationBankingDetailsComponent},
  {path: 'activation-vehicle-details', component: ActivationVehicleDetailsComponent},
  {path: 'activation-cover-details', component: ActivationCoverDetailsComponent},
  {path: 'activation-quote-details', component: ActivationQuoteActivateDetailsComponent}
];


@NgModule({
  declarations: [
    AppComponent,
    QuotationTrackerComponent,
    StepOneComponent,
    StepTwoComponent,
    StepThreeComponent,
    ContentComponent,
    ErrorComponent,
    StriphtmlPipe,
    ThankYouComponent,
    QuotePipe,
    MoreVehicleInfoComponent,
    EarlyExitComponent,
    LeadFormComponent,
    StepperComponent,
    QuoteStepOneComponent,
    QuoteStepTwoComponent,
    SearchByMakeComponent,
    ParkingQuestionsComponent,
    MainDriverDetailsComponent,
    LicenseDetailsComponent,
    QuoteStepThreeComponent,
    ActivationPlanholderDetailsComponent,
    ActivationBankingDetailsComponent,
    ActivationVehicleDetailsComponent,
    ActivationCoverDetailsComponent,
    ActivationQuoteActivateDetailsComponent,
    PremiumBannerComponent,
    ScrollDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    RouterModule.forRoot(routes, {useHash: true}),
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    SlickCarouselModule,
    MatAutocompleteModule
  ],
  providers: [
    QuotationService,
    ValidationService,
    LeadService,
    ContentComponent,
    CookieService,
    DiscoveryGa4AngularService,
    GoogleAnalyticsService,
    CampaignTrackingService,
    GtmService
  ],
  bootstrap: [AppComponent],
  exports: [StriphtmlPipe]
})
export class AppModule {
}
